import firebase from 'firebase/app';
import 'firebase/auth';

export const auth = firebase.initializeApp  ({
    apiKey: "AIzaSyAb2GVUIGUC55dOYEUO9ZjH7K7h6cY4jLE",
    authDomain: "chatuniverse-d7909.firebaseapp.com",
    projectId: "chatuniverse-d7909",
    storageBucket: "chatuniverse-d7909.appspot.com",
    messagingSenderId: "400223608945",
    appId: "1:400223608945:web:e52381157a5e54cfeefbd0",
    measurementId: "G-GNT3SN123X"
  }).auth();